<select for="select-lang-label" id="select-lang" class="form-control" #langSelect [(ngModel)]="lang" (change)="changeLang(langSelect)">
    <option value="en">{{'English' | translate}}</option>
    <option value="ko">{{'Korean' | translate}}</option>
</select>
